import { Map } from 'immutable';
import { Observable } from 'rxjs';

import Api from '../api';

import WalletTransaction from './model';
import { addMultipleAction } from './actions';
import { WalletTransactionMap } from './reducer';

export default class WalletTransactionApi {
  static getWalletTransactions(
    userId: string
  ): Observable<{ type: string; walletTransactions: WalletTransactionMap }> {
    return Api.get(`api/walletTransactions/users/${userId}`).map(
      (walletTransactions: WalletTransaction[]) =>
        addMultipleAction(
          Map(
            walletTransactions.map((walletTransaction: WalletTransaction) => [
              walletTransaction.id,
              new WalletTransaction(walletTransaction),
            ])
          )
        )
    );
  }
}
